const rich = {
	path: '/richdoor',
	name: 'richdoor',
	component: () => import("@views/rich-door/richdoor.vue"),
	children: [
		{
			path: 'index',
			component: () => import("@views/rich-door/index.vue"),
			meta:{
			}
		},
		//论坛库
		{
			path: 'forum',
			component: () => import("@views/rich-door/forum.vue")
		},
		//作用、意义
		{
			path: 'meaning',
			component: () => import("@views/rich-door/meaning.vue"),
			meta: {
				tabBar: false
			},
		},
		//文章详情
		{
			path: 'details',
			name:'richdoor_details',
			component: () => import("@views/rich-door/details.vue"),
			meta: {
				tabBar: false,
				timeBar: true
			},
		},
		//五本驾照
		{
			path: 'driving-license',
			component: () => import("@views/rich-door/driving-license.vue"),
			meta: {
        // useKeepAlive:'false' //不用缓存
			}
		},
		//学员案例
		{
			path: 'student-case',
			component: () => import("@views/rich-door/student-case.vue")
		},
		//课程详情
		{
			path: 'course-details',
			name:'course-details',
			component: () => import("@views/rich-door/course-details.vue"),
			meta: {
				tabBar: false,
        useKeepAlive:'false'
      }
		},
		//考试流程
		{
			path: 'fitness-test',
			component: () => import("@views/rich-door/fitness-test.vue"),
			meta: {
				tabBar: false
			}
		},
		//测试结果
		{
			path: 'test-result',
			component: () => import("@views/rich-door/test-result.vue"),
			meta: {
				tabBar: false
			}
		},
		//所有答案
		{
			path: 'all-answer',
			component: () => import("@views/rich-door/all-answer.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path: 'seminar',
			component: () => import("@views/rich-door/seminar.vue"),
			meta: {
				tabBar: false,
				keepAlive: true
			}
		},
		//dtb美丽课堂
    {
      path: 'angel-classroom',
      component: () => import("@views/rich-door/angel-classroom.vue"),
      meta: {
        tabBar: false,
        keepAlive: true
      }
    },
		//dtb 慧活空间 —— 慧活学园
		{
			path: 'space-school',
			component: () => import("@views/rich-door/space-school.vue"),
			meta: {
				tabBar: false,
				keepAlive: true
			}
		}
	]
};

export default rich
